export default "__VITE_ASSET__e401517b__"